import classNames from 'classnames'
import { t } from 'i18next'
import { InputTextarea } from 'primereact/inputtextarea'
import { SelectButton } from 'primereact/selectbutton'
import { Tooltip } from 'primereact/tooltip'
import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { EducationReport } from '../../../../../model/enums/educationReport.model'
import { Competence } from '../../../../../services/competenceService'
import { replaceCompetenceKeyDashesWithDots } from '../../../../../util/replaceCompetenceKeyDashesWithDots'
import { educationReportRating } from '../../../observation/ObservationEntry'

export const SubCompetencesComponent = (methods: UseFormReturn<EducationReport>, editable: boolean) => {
	return (competence: Competence, parentIndex: number): JSX.Element[] | undefined => {
		return competence?.children?.map((subCompetence: Competence, index: number) => {

			const cssRef = `sid-${subCompetence.dbId}`
			const compChildrenText: string[] | undefined = subCompetence?.children?.map(sc => t<string>(sc.label))

			return (
				<div
					key={'diva_' + subCompetence.key}
					className={'formgroup-inline p-0 m-0 grid align-items-center'}
				>
					<div className={'md:col-4 p-0 pr-2 m-0 flex-grow-1'}>
						<label className={'w-full'}>
							<span className={'pr-2'}>
								{replaceCompetenceKeyDashesWithDots(
									subCompetence?.key
								)} {t<string>(subCompetence?.label)}
							</span>
							{compChildrenText !== undefined && <>
								<Tooltip
									appendTo={document.body}
									position={'top'}

									target={`.${cssRef}`}
									content={compChildrenText?.join(',\n')}
								/>
								<i className={'m-0 flex-end fas fa-question-circle icon-light-gray '
									+ cssRef}
								/>
							</>
							}
						</label>
						<br />
						<Controller
							name={`competence.${parentIndex}.sub_competence_assessment.${index}.rating`}
							control={methods.control}
							render={({ field, fieldState }) => (
								<SelectButton
									key={'select_' + subCompetence.dbId}
									id={field.name}
									{...field}
									value={field.value}
									tooltip={t<string>('core.rating.explanation')}
									tooltipOptions={{ appendTo: document.body, position: 'top' }}
									options={educationReportRating()}
									className={classNames({ 'p-invalid': fieldState.error }, 'w-full p-0')
									}
									disabled={!editable}
								/>
							)} />
					</div>
					<div className={'md:col-8 p-0 m-0 flex-grow-1'}>
						<label className={'secondary-text small-text'}>
							{t<string>('core.education.explanation')}
						</label>
						<Controller
							name={`competence.${parentIndex}.sub_competence_assessment.${index}.reason`}
							control={methods.control}
							render={({ field, fieldState }) => (
								<InputTextarea
									{...field}
									id={field.name}
									autoResize={true}
									value={field.value || ''}
									className={classNames({ 'p-invalid': fieldState.error }, 'button-height w-full')
									}
									disabled={!editable}
								/>
							)} />
					</div>
				</div>
			)
		})
	}
}